import styled from 'styled-components';
import { GlobalToken } from 'antd';

interface GeneralContainerProps {
  $hasFinishedWizard: boolean;
  theme: {
    token: GlobalToken;
  };
}

export const GeneralContainer = styled.div<GeneralContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    margin-left: ${({ theme: { token } }) => token.marginXXL}px;
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
  }

  .flex-row {
    display: flex;

    .component-rows-container {
      width: 100%;

      .component-row {
        &:first-child {
          padding-top: ${({ theme: { token } }) => token.paddingLG}px;
        }
        display: flex;
        width: 100%;
        padding-top: ${({ theme: { token } }) => token.paddingXL}px;
        padding-bottom: ${({ theme: { token } }) => token.paddingXL}px;
        border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorder};

        .component-label {
          display: flex;
          width: 220px;
          height: 28px;
          align-items: center;
        }

        .component-controls {
          height: 28px;

          .engine-ready-switch-container {
            display: flex;
            align-items: center;

            .switch-label {
              font-size: ${({ theme: { token } }) => token.fontSize}px;
              color: ${({ theme: { token } }) => token.colorBorder};
            }

            .engine-ready-switch {
              margin: 0 ${({ theme: { token } }) => token.marginXS}px;
            }

            .ant-switch {
              background-color: ${({ theme: { token } }) => token.colorBgElevated};
              height: 10px;
              width: 20px;

              .ant-switch-handle::before {
                background-color: ${({ theme: { token } }) => token.colorPrimary};
                top: -5px;
                left: -2px;
                height: 16px;
                width: 16px;
                border-radius: 50%;
              }

              .ant-switch-loading-icon {
                top: 16px;
                left: 18px;
              }
            }

            .ant-switch-checked {
              .ant-switch-handle::before {
                background-color: ${({ theme: { token } }) => token.colorPrimary};
              }

              .ant-switch-loading-icon {
                color: ${({ theme: { token } }) => token.colorText};
                top: 10px;
                left: 2px;
              }

              &:focus {
                box-shadow: unset;
              }
            }

            .ant-switch-inner {
              color: ${({ theme: { token } }) => token.colorBgElevated};
              font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
            }
          }
        }
      }
    }
  }

  .card {
    width: 1032px;
    min-height: ${({ $hasFinishedWizard }: { $hasFinishedWizard: boolean }) =>
      $hasFinishedWizard ? '535px' : '611px'};
    background-color: ${({ theme: { token } }) => token.colorBgContainer};
  }
`;
